import {useState} from "react";
import ForgetFormStep1 from "./ForgetFormStep1";
import ForgetFormStep2 from "./ForgetFormStep2";
import ForgetFormStep3 from "./ForgetFormStep3";


const ForgetForm = () => {
    const [step, setStep] = useState(1);
    const [data, setData] = useState({});

    return (
        <div className='w-100 text-center py-5'>
            {
                {
                    1: <ForgetFormStep1 onDone={(params) => {
                        setData(params);
                        setStep(2)
                    }}/>,
                    2: <ForgetFormStep2 email={data?.email || ''} onDone={() => {
                        setStep(3);
                    }} back={() => setStep(1)}/>,
                    3: <ForgetFormStep3/>
                }[step]
            }
        </div>
    )
}

export default ForgetForm;